
import { BasicModel } from "@goodgamestudios/core";
import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2DialogEvent } from "../../../event/Poker2DialogEvent";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";

import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;

export class Poker2BoosterBuyDialog extends Poker2Dialog {
    public static NAME: string = "Poker2BoosterBuyDialog";
    private ITEMS_PER_PAGE: number = 4;
    private selectedBoosterId: number = 0;
    private boosterComponent: Poker2BoosterComponent;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    public show(): void {
        super.show();
        this.controller.addEventListener("changeBooster", this.bindFunction(this.onChangeBooster));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2BoosterBuyDialog", 1]));

        this.boosterComponent.fillItems();
        this.boosterComponent.fillOwnBooster();
    }

    protected init(): void {
        super.init();
        this.boosterComponent = new Poker2BoosterComponent(this.boosterBuyDialog);
    }

    public hide(): void {
        super.hide();
        this.controller.removeEventListener("changeBooster", this.bindFunction(this.onChangeBooster));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2BoosterBuyDialog", 0]));
    }

    protected applyProperties(): void {
        super.applyProperties();
        this.boosterComponent.applyProperties();
    }

    private onChangeBooster(event: Event): void {
        this.boosterComponent.fillItems();
        this.boosterComponent.fillOwnBooster();
    }

    private validateBooster(boosterId: number): void {
        this.selectedBoosterId = boosterId;

        //TIME UPGRADE
        if (Poker2Model.inventoryData.hasBoosterByWodId(boosterId)) {
            this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("dialog_buybooster_extend"), this.bindFunction(this.buyBooster)));
        }
        else if (!Poker2Model.inventoryData.hasBoosterByWodId(boosterId) && !Poker2Model.inventoryData.hasHigherBooster(boosterId)) {
            //BUY ACTION
            if (!Poker2Model.inventoryData.hasHigherBooster(boosterId) && !Poker2Model.inventoryData.hasLowerBooster(boosterId))
                this.buyBooster(null);
            else
                //OVERRIDE
                if (Poker2Model.inventoryData.hasLowerBooster(boosterId))
                    this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("dialog_buybooster_override"), this.bindFunction(this.buyBooster)));
        }

    }

    private buyBooster(params: any[]): void {
        if (this.selectedBoosterId >= 0)
            BasicModel.smartfoxClient.sendMessage("bbu", [JSON.stringify({ id: this.selectedBoosterId })]);
    }

    protected onMouseOver(event: MouseEvent): void {
        super.onMouseOver(event);

        if (event.target == this.boosterBuyDialog.btn_info)
            this.boosterBuyDialog.mc_info.visible = true;
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);

        if (event.target == this.boosterBuyDialog.btn_info)
            this.boosterBuyDialog.mc_info.visible = false;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.boosterBuyDialog.btn_close:
                this.hide();
                break;
            case this.boosterBuyDialog.booster0.btn_buy:
            case this.boosterBuyDialog.booster1.btn_buy:
            case this.boosterBuyDialog.booster2.btn_buy:
            case this.boosterBuyDialog.booster3.btn_buy:
                this.validateBooster(event.target.boosterId);
                break;
        }
    }

    protected get boosterBuyDialog(): Library.PokerInterface.PokerBooster {
        return this.disp as Library.PokerInterface.PokerBooster;
    }
}
import { Poker2BoosterComponent } from "../../components/booster/Poker2BoosterComponent";
import { Poker2StandardYesNoDialog } from "../Poker2StandardYesNoDialog";
